import { render, staticRenderFns } from "./PrintTempAdd.vue?vue&type=template&id=36900c10&scoped=true"
import script from "./PrintTempAdd.vue?vue&type=script&lang=js"
export * from "./PrintTempAdd.vue?vue&type=script&lang=js"
import style0 from "./PrintTempAdd.vue?vue&type=style&index=0&id=36900c10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36900c10",
  null
  
)

export default component.exports